import React, { useState, useEffect, useRef } from 'react';
import { Scatter } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  PointElement,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';
import { numberToDate } from '../../../helpers/numberToDate';

ChartJS.register(PointElement, LinearScale, Tooltip, Legend);

const ChartRiskHeatmapComp = (props) => {
  const [dataPoints, setDataPoints] = useState([]);
  const chartRef = useRef(null);

  // Fungsi untuk generate 3 data points
  const generateHeatmapData = (props) => {
    const data = props?.listRiskHeatmap || [];

    const heatmapData = data.map((item) => ({
      x: Number(item.impactAnalysis),
      y: Number(item.probabilityAnalysis),
      r: data?.length,
      codeRisk: item.codeRisk,
      createdAt: numberToDate(item.createdAt),
    }));

    return heatmapData.slice(0, data?.length);
  };

  useEffect(() => {
    const points = generateHeatmapData(props);
    setDataPoints(points);
  }, []);

  const data = {
    datasets: [
      {
        label: 'Grafik Peta Panas',
        data: dataPoints,
        backgroundColor: '#0d6efd',
      },
    ],
  };

  // Plugin custom untuk menggambar background gradient diagonal
  const gradientBackgroundPlugin = {
    id: 'customGradientBackground',
    beforeDraw: (chart) => {
      const { ctx, chartArea } = chart;
      const { left, right, top, bottom } = chartArea;

      // Buat gradient diagonal dari kiri atas ke kanan bawah
      const gradient = ctx.createLinearGradient(left, bottom, right, top);

      // Tambahkan warna gradasi
      gradient.addColorStop(0, 'blue'); // awal: biru
      gradient.addColorStop(0.33, 'green'); // tengah awal: hijau
      gradient.addColorStop(0.66, 'yellow'); // tengah akhir: kuning
      gradient.addColorStop(1, 'red'); // akhir: merah

      // Simpan state dan gambar background
      ctx.save();
      ctx.fillStyle = gradient;
      ctx.fillRect(left, top, right - left, bottom - top);
      ctx.restore();
    },
  };

  const options = {
    scales: {
      x: {
        type: 'linear',
        position: 'bottom',
        min: 0,
        max: 6,
        ticks: {
          stepSize: 1,
        },
      },
      y: {
        min: 0,
        max: 6,
        ticks: {
          stepSize: 1,
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            const { x, y, codeRisk, createdAt } = context.raw;
            return ` R.${codeRisk}, (Dampak: ${x}, Probabilitas: ${y}, Dibuat: ${createdAt})`;
          },
        },
      },
    },
  };

  return (
    <>
      <div className="w-full h-[400px] p-4">
        <h2 className="text-xl mb-4 text-danger">Dashboard Peta Panas</h2>
        <hr className="my-3" />
        <Scatter
          data={data}
          options={options}
          ref={chartRef}
          plugins={[gradientBackgroundPlugin]}
        />
      </div>
    </>
  );
};

export default ChartRiskHeatmapComp;
